/* eslint-disable no-nested-ternary */
import React from 'react';
import { map, find, isEmpty, get, isUndefined } from 'lodash';

import { withNetworkState } from 'ui/hoc/withNetworkState';
import { getLabel } from 'utils/getLabel';
import { getDisplayValue } from 'resolvers/formatValue';

// Local Dependencies
import { Icon } from 'modules/icon-bank';
import { button as Button } from 'modules/button';
 
/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberSecuritySettingsInfo as MemberSecuritySettingsInfo } from 'ui/views/widgets/memberSecuritySettingsInfo';
 *
 * // render
 * <MemberSecuritySettingsInfo propName='propValue'/>
 */

// Success View
const memberSecuritySettingsInfoSuccess = ( props ) => {

	const { showCustomErrorView = false, description } = props;

    const editEmail = find( props.actions, { name: 'editEmail' } );
    const reset = find( props.actions, { name: 'editPassword' } );
	const sendOtp = find( props.actions, { name: 'sendotp' } );
	const visibility = get( props, 'visibility', [] );
	
	if( showCustomErrorView ) {
		return (
			<div className="ui-member-security-settings-info-default">
 				<div className='ui-member-security-settings-info-default__icon'>
                    <Icon name='warningBlue' width={ 50 } height={ 50 } />
                </div>

				{/* sub-title */}
                <p className='ui-member-security-settings-info-default__title'>
                    { description }
                </p>

		</div>
		);
	}
	
	return (
		<div className="ui-member-security-settings-info">
			{ map( props.securityInfo.fields, ( field, sectionIndex ) => {
				 const isActive = visibility[ `${field.visibility}` ];
				return (
					    isActive?
                <div key={ sectionIndex } className='ui-member-security-settings-info__contact'>
                    <div className='ui-member-security-settings-info__contact__type-detail'>
						
                        <div className='ui-member-security-settings-info__contact__type-detail__type'>
							<div className='ui-member-security-settings-info__contact__actions__action__icon'>
								<Icon name={ getLabel( field.icon ) } height={ 16 } width={ 16 } fill='#4A4A4A'/>
							</div>
                        	{ getLabel( field.title ) }
                    	</div>

						{ 'email' === field.name && ! isUndefined( editEmail ) && (
							<div className='ui-member-security-settings-info__contact__actions__action' onClick={ () => props.editEmailAction( { action: editEmail, mode: 'add', field: { ...field, values: props.securityInfo.values } } ) }>
							
								<div className='ui-member-security-settings-info__contact__actions__action__icon'>
									<Icon name='edit' height={ 16 } width={ 16 }/>
								</div>
								<div className='ui-member-security-settings-info__contact__actions__action__name'>
									{ getLabel( get( editEmail, 'title', {} ) ) }
								</div>
							</div>
						) }
                    
						{  'password' === field.name && ! isUndefined( reset ) && (

							<div className='ui-member-security-settings-info__contact__actions__action' onClick={ () => props.resetPassword( { action: reset, field: { ...field, values: props.securityInfo.values } } ) }>
								<div className='ui-member-security-settings-info__contact__actions__action__name'>
									{ getLabel( get( reset, 'title', {} ) ) }
								</div>
							</div>
						) }

                    </div>
					
					{ 'password' !== field.name? (
						<div className='ui-member-security-settings-info__contact__contact-number'>
							{ getDisplayValue( { type: field.type, value: props.securityInfo.values[ field.name ], } ) }
						</div>
					) : (
						<div  className='ui-member-security-settings-info__password'>
							{ map( [ 1, 2, 3, 4, 5, 6, 7, 8 ], item => <div key={ item } className='ui-member-security-settings-info__password__disc'/> ) }
						</div>
					) }
                </div> :null
				);
			} ) }
			<div className='ui-member-security-settings-info__contact__actions'>
				{ ! isEmpty( sendOtp ) &&
					<Button
						className='ui-member-security-settings-info__contact__actions__item ui-member-security-settings-info__contact__actions__item'
						title={ { refId: '', value: getLabel( sendOtp.confirmation ) } }
						outline={ false }
						size='medium'
						onClick={ () => props.sendOTP( { action: sendOtp, field: props.securityInfo.values } ) }
					/>
				}
			</div>
		</div>
	);
};

// set display name
memberSecuritySettingsInfoSuccess.displayName = 'memberInfoSecuritySettings';

// set default props
memberSecuritySettingsInfoSuccess.defaultProps = {};

// prop types
memberSecuritySettingsInfoSuccess.propTypes = {};

/*******************************/

// preloader view
export const memberSecuritySettingsInfoPreloader = () => {
	return (
		<div className="ui-member-info-security-settings-preloader">
			
			{ map( [ 1, 2, 3 ], ( item ) => {
				return (
					<div key={ item } className="ui-member-info-security-settings-preloader__contact">
						<div className="ui-member-info-security-settings-preloader__contact__type-detail">
							<div className="ui-member-info-security-settings-preloader__contact__type-detail__type"></div>
							<div className="ui-member-info-security-settings-preloader__contact__type-detail__default"></div>
						</div>
						<div className="ui-member-info-security-settings-preloader__contact__contact-number"></div>
					</div>
				);
			} ) }
		</div>
	);
};

// set display name
memberSecuritySettingsInfoPreloader.displayName =
	'memberSecuritySettingsPreloader';

// set default props
memberSecuritySettingsInfoPreloader.defaultProps = {};

// prop types
memberSecuritySettingsInfoPreloader.propTypes = {};

/*******************************/

export const memberSecuritySettingsInfo = withNetworkState(
	memberSecuritySettingsInfoPreloader,
	memberSecuritySettingsInfoSuccess
);
